<script setup lang="ts">
import * as routeNames from '@/constants/routeNames';
</script>

<template>
  <section
    :class="$style.airRoadJobErrorEmptyState"
    data-testid="airRoadJobErrorEmptyState"
  >
    <header :class="$style.header">
      <div :class="$style.bigPic">
        <v-icon icon="mdi mdi-cube-off-outline"></v-icon>
      </div>
      <h1 :class="$style.h1">AirRoad Job Error</h1>
    </header>

    <div :class="$style.main">
      <p :class="$style.text">
        <slot>Something went wrong.</slot>
      </p>
    </div>

    <footer :class="$style.footer">
      <ul :class="$style.linksBasicList">
        <li>
          <router-link :to="{ name: routeNames.AIR_ROAD_BOOKED }">
            Go to AirRoad booked page
          </router-link>
        </li>
      </ul>
    </footer>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.airRoadJobErrorEmptyState {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
}
  .header {
    padding: 20px;
  }
    .bigPic {
      width: 178px;
      height: 178px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: colors.$color-gray-100;
      color: colors.$color-red-800;
      font-size: 67px;
      border: 2px solid colors.$color-red-800
    }
    .h1 {
      color: colors.$color-text-secondary;
      font-size: 32px;
      margin-bottom: 0;
      text-align: center;
    }
  .main {
    padding: 10px;
  }
    .text {
      color: colors.$color-text-secondary;
      font-size: 24px;
      margin: 0;
    }
  .footer {
    padding: 20px;
  }
    .linksBasicList {
      list-style: none;
      font-size: 18px;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
      .logoImgLink {
        margin: 30px 0 0 0;
        display: block;
      }
</style>
